import React, { FC } from 'react';
// import Link from 'next/link';
import { Link } from '../../components/Link';

import Arrow from '../../components/Arrow';
import PGCard from '../../components/PGCard';

import styles from './PGLastNews.module.scss';

interface Props {
  PGLastNewsData: { [key: string]: string };
  PlaygroundList: Array<{ [key: string]: any }>;
}
const PGLastNews: FC<Props> = (props) => {
  const { PGLastNewsData, PlaygroundList } = props;

  return (
    <section className={styles['pg-lastnews-box']}>
      <div className={styles['lastnews-title-box']}>
        <h2 className={styles['lastnews-title']}>{PGLastNewsData.title}</h2>
        {PGLastNewsData.moreLink && (
          <Link href={PGLastNewsData.moreLink} legacyBehavior prefetch={false}>
            <a className={styles['lastnews-more-box']}>
              <div className={styles['lastnews-more-btn']}>{PGLastNewsData.moreText}</div>
              <div className={styles['more-arrow-box']}>
                <Arrow />
              </div>
            </a>
          </Link>
        )}
      </div>
      <div className={styles['lastnews-data-box']}>
        {PlaygroundList?.map((item, index) => (
          <div key={index} className={styles['amout-data-item']}>
            <PGCard pgCardData={item} />
          </div>
        ))}
      </div>
    </section>
  );
};

PGLastNews.displayName = 'PGLastNews';
export default PGLastNews;
